export default "__VITE_ASSET__DQy6f36C__"